import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import TextInput from "../TextInput";
import { countries } from "../../constants/countryCodes";
import { useTranslate } from "../../hooks/useTranslate";
import Autocomplete from "../Autocomplete";
import "./PhoneNumberInput.css";
import { isVersionUK } from "../../services/versionService";

const firstOption = isVersionUK ? "+44" : "+1";

const codeOptions = [...new Map(countries.map((item) => [item.dialCode, item])).values()]
    .toSorted((a, b) => {
        if (a.dialCode === firstOption) return -1;
        if (b.dialCode === firstOption) return 1;
        return a.dialCode - b.dialCode;
    })
    .map((country) => ({
        id: country.isoCode3,
        value: country.dialCode,
        label: country.dialCode,
        icon: country.flag,
    }));

const PhoneNumberInput = (props) => {
    const {
        label, register, control,
        name, error,
        nameCountryCode, errorCountryCode,
        disabled,
    } = props;

    const { t } = useTranslate();

    return (
        <FormControl error={!!error || !!errorCountryCode} className={`phone-number-input${disabled ? " field-disabled" : ""}`}>
            {label && <label htmlFor={name}>{label}</label>}
            <div className="phone-number-input__inputs">
                <Autocomplete
                    control={control}
                    name={nameCountryCode}
                    error={(error || errorCountryCode)}
                    options={codeOptions}
                    getOptionLabel={(option) => {
                        if (option?.icon && option?.label) return `${option.icon} ${option.label}`;
                        const fullOption = codeOptions.find((item) => item.id === option.id || item.value === option.id) || {};
                        return `${fullOption.icon} ${fullOption.label}`;
                    }}
                    helpertextrequired={false}
                    disabled={disabled}
                />
                <TextInput
                    register={register}
                    name={name}
                    error={(error || errorCountryCode)}
                    helperTextRequired={false}
                    disabled={disabled}
                />
            </div>
            {(error || errorCountryCode) ? <FormHelperText>{error || errorCountryCode}</FormHelperText> : null}
        </FormControl>
    );
};

export default PhoneNumberInput;
